import { Instant, InstantSchema } from "@/Temporal"
import { objectSchema } from "vue-utils"

export interface TideWaterMark {
	time: Instant
	height: number
}

export const TideWaterMark = objectSchema<TideWaterMark>({
	time: InstantSchema,
	height: Number,
})

export interface Tide {
	lowWater: TideWaterMark
	highWater: TideWaterMark
}

export const Tide = objectSchema<Tide>({
	lowWater: TideWaterMark,
	highWater: TideWaterMark,
})

export enum TideState {
	Rising = "Rising",
	Falling = "Falling",
}
